// PnL card share event — fires when a user shares an individual market
// position via the per-(market, outcome) share button.

import type { EventDefinition } from './navigation';

export type PnlCardSharedMethod = 'copy' | 'native' | 'x' | 'telegram' | 'whatsapp' | 'reddit';

export type PnlCardSharedProperties = {
  marketPubkey: string;
  walletPubkey: string;
  outcomeIndex: number;
  method: PnlCardSharedMethod;
};

export const PNL_CARD_SHARED: EventDefinition<PnlCardSharedProperties> = {
  name: 'pnl_card_shared',
};
